// extracted by mini-css-extract-plugin
export default {"root":"reportIntro_root__MNWgc","headline":"reportIntro_headline__5UUe8","instruction":"reportIntro_instruction__ZcPjS"};